import { ActivityFeed } from '../types';
import { apiService } from './apiService';

class ActivityService {
  async getActivity(options: { date?: string; chargerId?: string; limit?: number } = {}): Promise<ActivityFeed> {
    const params = new URLSearchParams();
    if (options.date) params.set('date', options.date);
    if (options.chargerId) params.set('chargerId', options.chargerId);
    if (options.limit) params.set('limit', String(options.limit));

    const query = params.toString();
    return apiService.get<ActivityFeed>(`/activity${query ? `?${query}` : ''}`);
  }
}

export const activityService = new ActivityService();
